import { createFileRoute, useSearch, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { CondemnationForm } from "@/features/condemnation/CondemnationForm";
import { canCreateCondemnation } from "@/lib/roles";
import { currentUserQueryOptions } from "@/hooks/useCurrentUser";

export const Route = createFileRoute("/_authenticated/condemnation/new")({
  validateSearch: z.object({ assetId: z.string().optional() }),
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(currentUserQueryOptions());
    if (!canCreateCondemnation(me.roles)) throw redirect({ to: "/condemnation" });
  },
  component: NewCondemnation,
});

function NewCondemnation() {
  const search = useSearch({ from: "/_authenticated/condemnation/new" });
  return <CondemnationForm presetAssetId={search.assetId} />;
}
